import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchRecentsListHeadingStyled } from './styles/GlobalSearchRecentsListHeadingStyled'
import { type GlobalSearchRecentItem } from '../../../../value-objects/GlobalSearchRecentItem'
import { GlobalSearchListItem } from '../GlobalSearchListItem'

interface IGlobalSearchRecentsListProps {
  items: GlobalSearchRecentItem[]
  onRecentItemClick: (item: GlobalSearchRecentItem) => void
}

export const GlobalSearchRecentsList = ({
  items,
  onRecentItemClick,
}: IGlobalSearchRecentsListProps) => {
  const intl = useProcurifyIntl()

  return (
    <div>
      <GlobalSearchRecentsListHeadingStyled color='textSecondary'>
        {intl.formatMessage(messages.recentHeading)}
      </GlobalSearchRecentsListHeadingStyled>
      {items.map((item) => (
        <GlobalSearchListItem
          key={item.uuid}
          type={item.type}
          id={item.id}
          metadata={item.metadata}
          onClick={() => onRecentItemClick(item)}
        />
      ))}
    </div>
  )
}
